import { render } from "./GinaNeculaesPage.vue?vue&type=template&id=0d11387e"
import script from "./GinaNeculaesPage.vue?vue&type=script&lang=js"
export * from "./GinaNeculaesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__